import React from 'react';
import produce from 'immer';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { ButtonBase } from '@mui/material';

import { get, cloneDeep, isEqual } from '../../../../utils/lodash';

import { Card, Button, TextField } from '@mui/material';

import Node from '../../../../common/Node';
import Search from '../../../../common/Search';
import LoaderNew from '../../../../common/LoaderNew';
import CommonStyles from '../../../../common/CommonStyles';
import ComponentWrapper from '../../../../common/ComponentWrapper';
import FullScreenDialog from '../../../../common/FullScreenDialog';
import TrplSelect from '../../../../common/TrplControls/TrplSelect';
import ViewUsesTree from '../../ViewUsesTree';

import Clear from '@mui/icons-material/Clear';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import TrplCheckbox from '../../../../common/TrplControls/TrplCheckbox';

import ListEdit from './components/ListEdit';
import TableEdit from '../TableEdit/TableEdit';
import AccordeonEdit from './components/AccordeonEdit';
import DashboardEdit from './components/DashboardEdit';
import TableChildEdit from './components/TableChildEdit';
import TrplFormEditModal from './components/TrplFormEditModal';

import { changeArrayElementPosition, getAllFormConcepts, getConceptRsts, getRandomId, getLastRstData } from '../../../../utils';
import { jelTypes, colPadding } from '../../../../constants';

import { updateJels, updateJelsSimple } from '../../../../reducer/jelsReducer';

const itemTypesValues = [
  { title: 'List', value: 'list' },
  { title: 'Table', value: 'table' },
  { title: 'Links', value: 'links' },
  { title: 'Accordeon', value: 'accordeon' },
];

const styles = {
  groupsRow: {
    background: '#F1F1F6',
    flexDirection: 'column',
    marginBottom: '10px',
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.16)',
  },
  groupRow: {
    background: '#fff',
    padding: '10px',
    marginBottom: '10px',
  },
  groupContent: {
    display: 'flex',
    flexDirection: 'column',
    height: 'calc(100% - 20px)',
  },
  groupContentInner: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
  },
  linkCell: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  tCell: { padding: '2px 10px' },
  titleTCell: { padding: '2px', width: '300px' },
  notValidAccordeonRst: {
    '& .autocomplete-input': {
      color: 'red',
    },
  },
  isInAnotherJelContainer: {
    left: 0,
    right: 0,
    color: '#fff',
    zIndex: '9999',
    display: 'flex',
    fontSize: '13px',
    position: 'static',
    padding: '8px 60px',
    alignItems: 'center',
    background: '#347CFF',
    justifyContent: 'center',
  },
  ...CommonStyles,
  checkboxGray: {
    padding: '0px',
    height: '16px',
    '& .MuiSvgIcon-root': {
      color: '#675E78',
      fontSize: '18px',
    },
  },
  removeNotValidRstrsBtn: {
    color: 'red',
    fontSize: 12,
    height: 'fit-content',
    textTransform: 'none',
  },
  tableEditInput: {
    '& .MuiInputBase-input': {
      fontSize: '12px',
    },
  },
  rowDragHandle: {
    display: 'flex',
    color: '#C4C4C4',
    marginRight: '10px',
    '&:hover': {
      color: '#4E4C4C',
    },
  },
  editFrmIcon: {
    color: '#878787',
    '&:hover': {
      color: '#4E4C4C',
      cursor: 'pointer',
    },
  },
  checkboxLabel: {
    padding: '0px',
    height: '16px',
    fontSize: '12px',
    '& .MuiSvgIcon-root': {
      color: '#675E78',
    },
  },
};

class TrplFormEdit extends ComponentWrapper {
  state = {
    tbls: [],
    flows: [],
    flowsValues: [],
    form: {
      tabs: false,
      title: '',
      groups: [],
      concept: null,
      tabsTitles: [],
    },
    data: {
      setup: {
        locations: {},
      },
      nodes: {},
    },
    modalData: {
      type: 'list',
      rowIndex: null,
      isOpened: false,
      groupIndex: null,
    },
    editTblModal: {
      isOpened: false,
      data: {},
    },
    editFrmModal: {
      isOpened: false,
      data: {},
    },
    conceptRestrictionsIds: [],
    ancestorsRstList: {},
    usedViews: {},
    loaded: false,
    deepCopyLoaded: true,
    addSecondaryConcepts: false,
  };

  componentDidMount() {
    const { form, jels, accounts_tbox, createMode } = this.props;

    const flowsValues = [{ title: 'none', value: 'none' }];

    jels && jels.flows && jels.flows.forEach((flow) => flowsValues.push({ title: flow.title, value: flow.id }));

    let isInAnotherJel = ``;

    if (form && form.id) {
      jels.tables.forEach((tblId) => {
        const tbl = jels.jelData[tblId];

        if (tbl.buttons && tbl.buttons.editNode && form.id === tbl.buttons.editNode)
          isInAnotherJel += (isInAnotherJel ? ', ' : '') + `${tbl.id} ${tbl.title}`;
      });

      jels.forms.forEach((frmId) => {
        const frm = jels.jelData[frmId];

        frm && frm.groups && frm.groups.forEach((row) => {
          row && row.forEach((group) => {
            if (group.type === 'links') {
              group.links.forEach((link) => {
                if (link.jel === form.id)
                  isInAnotherJel += (isInAnotherJel ? ', ' : '') + `${frm.id} ${frm.title}`;
              });
            }

            if (group.items && group.items.length) {
              group.items.forEach(item => {
                if (item.obj_editable_frm && item.obj_editable_frm === form.id)
                  isInAnotherJel += (isInAnotherJel ? ', ' : '') + `${frm.id} ${frm.title}`;
              })
            }

            if (group.type === 'accordeon' && (group.frmId === form.id || group.frmEditId === form.id))
              isInAnotherJel += (isInAnotherJel ? ', ' : '') + `${frm.id} ${frm.title}`;
          });
        });
      });

      jels.dashboards.forEach((dashboardId) => {
        const dashboard = jels.jelData[dashboardId];

        if (dashboard.views) {
          dashboard.views.forEach((view) => {
            if (form && view.value && form.id && view.value === form.id && accounts_tbox.nodes[dashboard.acc_concept]) {
              isInAnotherJel += (isInAnotherJel ? ', ' : '')
                + `${dashboard.id} ${accounts_tbox.nodes[dashboard.acc_concept].title}`;
            }
          });
        }
      });
    }

    this.setState({
      flowsValues,
      isInAnotherJel,
    }, () => {
      if (form) this.prepareData(createMode ? form.concept : null, true);
    });
  };

  addConcept = (obj, newValue) => {
    // Check if there's any key with a null value and update it
    for (let key in obj) {
      if (obj[key] === null) {
        obj[key] = newValue;
        return obj;
      }
    }
  
    // Find the highest numbered concept key
    let highestNumber = 0;
    for (let key in obj) {
      if (key.startsWith('concept_')) {
        const number = parseInt(key.split('_')[1]);
        if (number > highestNumber) {
          highestNumber = number;
        }
      }
    }
  
    // If no numbered concept key is found, set the next number to 1
    const nextNumber = highestNumber ? highestNumber + 1 : 2;
  
    // Add the new concept key
    const newKey = `concept_${nextNumber}`;
    obj[newKey] = newValue;
  
    return obj;
  };

  prepareData = (ancestor, getFormFromProps) => {
    const { light_meta_and_ops } = this.props;

    let newConceptRestrictionsIds = {};
    let newAncestorsRstList = {};

    let form = getFormFromProps ? cloneDeep(this.props.form) : cloneDeep(this.state.form);

    this.setState({ loaded: false }, () => {
      if (ancestor) form = this.addConcept(form, ancestor);

      const setupRboxLight = light_meta_and_ops && light_meta_and_ops.setup_rbox_light;
      const formConcepts = getAllFormConcepts(form);

      if (formConcepts && Object.values(formConcepts).length) {
        Object.values(formConcepts).forEach((ancestorId, index) => {
          if (ancestorId && setupRboxLight && setupRboxLight[ancestorId]) {
            const conceptKey = Object.keys(formConcepts);
            let rstList = getConceptRsts(ancestorId, setupRboxLight) || [];
            newAncestorsRstList = { ...newAncestorsRstList, [ancestorId]: rstList };
            newConceptRestrictionsIds = { ...newConceptRestrictionsIds, [conceptKey[index]]: new Set(rstList.map(rst => rst.id)) };
          }
        });
      }

      this.setState({
        form,
        formConcepts,
        loaded: true,
        ancestorsRstList: newAncestorsRstList,
        conceptRestrictionsIds: newConceptRestrictionsIds,
      });
    });
  };

  addNewGroup = (rowIndex, type) => {
    const form = cloneDeep(this.state.form);
    const formGroups = [...form.groups];
    const formGroup = [...formGroups[rowIndex]];
    const { formConcepts } = this.state;

    if (type === undefined) type = 'list';

    const groupObj = {
      width: '50%',
      type: type,
      title: '',
    };

    if (type === 'accordeon' && formConcepts && Object.keys(formConcepts).length > 1) {
      groupObj.concept_key = Object.keys(formConcepts)[0];
    }
  
    if (type === 'list') {
      groupObj.items = [];
    }

    if (type === 'table') {
      groupObj.tableId = '';
      groupObj.height = '50vh';
    }

    if (type === 'links') {
      groupObj.links = [];
    }

    formGroup.push(groupObj);

    form.groups = formGroups;
    form.groups[rowIndex] = formGroup;

    this.setState({ form });
  };

  onGroupFieldChange = (groupIndex, objIndex, field, value, cb) => {
    const form = cloneDeep(this.state.form);

    const immutableForm = produce(form, mutableForm => {
      mutableForm.groups[groupIndex][objIndex][field] = value;
    });

    this.setState({ form: immutableForm }, () => {
      if (cb) cb();
    });
  };

  onGroupLinkChange = (groupIndex, objIndex, linkIndex, field, value) => {
    const form = cloneDeep(this.state.form);

    if ((field === 'view_filters' && !value.length) || (field === 'view_sorter' && (!value.sort_pid))) {
      if (field in form.groups[groupIndex][objIndex].links[linkIndex])
        delete form.groups[groupIndex][objIndex].links[linkIndex][field];
    } else {
      form.groups[groupIndex][objIndex].links[linkIndex][field] = value;
    }

    this.setState({ form });
  };

  removeGroupLink = (groupIndex, objIndex, linkIndex) => {
    const form = cloneDeep(this.state.form);

    form.groups[groupIndex][objIndex].links.splice(linkIndex, 1);

    this.setState({ form });
  };

  onGroupRstFieldChange = (groupIndex, objIndex, itemIndex, field, value, isRenderer) => {
    const immutableForm = produce(this.state.form, mutableForm => {
      const group = mutableForm.groups[groupIndex][objIndex];
      
      if (!group.items) group.items = [];

      group.items[itemIndex][field] = value;

      if (field === 'obj_editable' && !value) {
        delete group.items[itemIndex].obj_editable_frm;
      }

      if (field === 'hide_title' && !value) {
        delete group.items[itemIndex].hide_title;
      }

      if (field === 'render_widget' && !value) {
        delete group.items[itemIndex].render_widget;
      }

      if (field === 'autocomplete' && !value) {
        delete group.items[itemIndex].autocomplete;
      }

      if (isRenderer) {
        const item = group.items[itemIndex];
        if (!item.hasOwnProperty('renderer')) item.renderer = { [field]: value };
        else item.renderer[field] = value;
        if (value === 'no icon' || ((field === 'true' || field === 'false') && value.toString() === '')) delete item.renderer[field];
        if (!Object.keys(item.renderer).length) delete item.renderer;
      }
    });

    this.setState({ form: immutableForm });
  };

  onRemoveRstFromGroupClick = (groupIndex, objIndex, elIndex) => {
    const form = cloneDeep(this.state.form);
    const formGroups = [...form.groups];
    const formGroupObj = { ...formGroups[groupIndex][objIndex] };
    const formGroupObjItems = [...formGroupObj.items];

    formGroupObjItems.splice(elIndex, 1);

    form.groups = formGroups;
    form.groups[groupIndex][objIndex].items = formGroupObjItems;

    this.setState({ form });
  };

  onGroupRstSelectChange = (groupIndex, objIndex, pid, concept) => {
    const form = cloneDeep(this.state.form);
    const formConcepts = getAllFormConcepts(form);
    const groupItems = [...form.groups[groupIndex][objIndex].items];

    const item = {
      pid,
      title: '',
      required: false,
      editable: true,
      // type: 'predicate',
    };

    if (formConcepts && Object.keys(formConcepts)
      && (Object.keys(formConcepts).length > 1 || Object.keys(formConcepts)[0] !== 'concept')) {
        item.concept_key = concept;
      }

    groupItems.push(item);

    form.groups[groupIndex][objIndex].items = groupItems;

    this.setState({ form });
  };

  addInnerRstCb = ({ groupIndex, objIndex, index, rstId }) => {
    const form = cloneDeep(this.state.form);
    const groupItems = [...form.groups[objIndex][groupIndex].items];
    
    if (groupItems[index].pid) {
      if (Array.isArray(groupItems[index].pid) && groupItems[index].pid.length > 1) {
        groupItems[index].pid = [...groupItems[index].pid, rstId];
      } else {
        groupItems[index].pid = [groupItems[index].pid, rstId];
      }
    } else {
      groupItems[index].pid = rstId;
    }

    if (groupItems[index]['trpl_filters']) delete groupItems[index]['trpl_filters'];
    if (groupItems[index]['render_widget']) delete groupItems[index]['render_widget'];
    if (groupItems[index]['obj_editable_frm']) delete groupItems[index]['obj_editable_frm'];
    if (groupItems[index]['renderer']) delete groupItems[index]['renderer'];

    this.setState({ form });
  };

  removeInnerRst = ({ groupIndex, objIndex, index }, newArr) => {
    const form = cloneDeep(this.state.form);
    const groupItems = [...form.groups[objIndex][groupIndex].items];

    if (newArr.length === 1) {
      groupItems[index].pid = newArr[0];
    } else {
      groupItems[index].pid = newArr;
    }

    if (!newArr.length) {
      delete groupItems[index].pid;
    }

    if (groupItems[index]['trpl_filters']) delete groupItems[index]['trpl_filters'];
    if (groupItems[index]['render_widget']) delete groupItems[index]['render_widget'];
    if (groupItems[index]['obj_editable_frm']) delete groupItems[index]['obj_editable_frm'];
    if (groupItems[index]['renderer']) delete groupItems[index]['renderer'];

    this.setState({ form });
  };

  onGroupComponentFieldChange = (groupIndex, objIndex, option, concept_key) => {
    const form = cloneDeep(this.state.form);
    const groupItems = [...form.groups[groupIndex][objIndex].items];
    const formConcepts = getAllFormConcepts(form);

    let newItem;
    if (option === 'custom') {
      newItem = { type: option, title: '', id: getRandomId() };
    } else {
      newItem = { type: option, title: '', required: false };
    }

    if (formConcepts && Object.keys(formConcepts)
      && (Object.keys(formConcepts).length > 1 || Object.keys(formConcepts)[0] !== 'concept')) {
        newItem.concept_key = concept_key;
      }

    groupItems.push(newItem);

    form.groups[groupIndex][objIndex].items = groupItems;

    this.setState({ form });
  };

  reassignAndCleanConceptKeys = (form) => {
    const conceptKeys = Object.keys(form).filter(key => key.includes('concept'));
    //const nonNullConceptKeys = conceptKeys.filter(key => form[key] !== null);
  
    // if (nonNullConceptKeys.length === 1) {
    //   const conceptValue = form[nonNullConceptKeys[0]];
    //   form['concept'] = conceptValue;
    //   if (nonNullConceptKeys[0] !== 'concept') {
    //     delete form[nonNullConceptKeys[0]];
    //   }

    //   form.groups && form.groups.forEach((row) => {
    //     row && row.forEach((group) => {
    //       if (group.items && group.items.length) {
    //         for (let i = 0; i < group.items.length; i++) {
    //           const item = group.items[i];
    //           if (item.concept_key) delete item.concept_key;
    //         }
    //       }
    //     });
    //   })
    // }

    // add rename all row items concept_key in form
  
    for (let key of conceptKeys) {
      if (form[key] === null) {
        delete form[key];
      }
    }
  
    return form;
  };

  onSaveFormClick = () => {
    const form = this.reassignAndCleanConceptKeys(cloneDeep(this.state.form));
    const { setParentJel, type } = this.props;

    if (form.draft) {
      delete form.id;
      delete form.draft;
    }

    if (!form.tabs && form.tabsTitles) delete form.tabsTitles;
    if (!form.type) form.type = jelTypes.form;

    form.groups.forEach((row) => {
      delete row.add_group_type;

      row.forEach((group) => {
        if (group.items && group.items.length) {
          for (let i = 0; i < group.items.length; i++) {
            const item = group.items[i];

            if (item.hasOwnProperty('custom_component')) {
              const newComponent = item.custom_component.map(row => {
                const newRowChildren = row.children.map(column => {
                  const newColumnChildren = column.children.map(comp => {
                    //delete comp.id;
                    return comp;
                  });
                  delete column.id;
                  return { ...column, children: newColumnChildren };
                });
                delete row.id;
                return { ...row, children: newRowChildren };
              });
              group.items.splice(i, 1, { ...item, custom_component: newComponent });
            }

            if (item.editable === undefined) item.editable = true;

            const pid = item.pid;
            const isValid = ((pid && Number.isInteger(+pid))
              || (Array.isArray(pid) && pid.length)) || (item.type && item.type === 'custom');

            if (!isValid) {
              group.items.splice(i, 1);
              i--;
            }
          }
        }

        if (!Number.isInteger(group.frmId)) delete group.frmId;
        if (!Number.isInteger(group.frmEditId)) delete group.frmEditId;
      });
    });

    this.setState({
      fetchingData: true
    }, () => {
      this.postWithData({
        url: '/rest/upd_jel?type=trpls_frm',
        data: form,
        cb: (data) => {
          if (data._status === 'ok') {
            this.setState({
              form: data.trpls_frm,
              fetchingData: false,
            });
            if (this.props.updateParentModalOnSave) this.props.updateParentModalOnSave(data.trpls_frm);
            if (setParentJel) setParentJel(data.trpls_frm.id, jelTypes.form, type, data.trpls_frm);
            if (this.props.updateJelsSimple) this.props.updateJelsSimple();
          }
        },
      });
    });
  };

  onConceptChange = (params) => {
    const { node } = params;
    if (node.id) this.prepareData(node.id, null);
  };

  changeGroupPosition = (rowIndex, oldIndex, newIndex) => {
    const form = cloneDeep(this.state.form);
    form.groups[rowIndex] = changeArrayElementPosition(form.groups[rowIndex], oldIndex, newIndex);

    this.setState({ form });
  };

  changeRowPosition = (oldIndex, newIndex) => {
    const form = cloneDeep(this.state.form);

    form.groups = changeArrayElementPosition(form.groups, oldIndex, newIndex);
    if (form.tabs && form.tabsTitles)
    form.tabsTitles = changeArrayElementPosition(form.tabsTitles, oldIndex, newIndex);

    this.setState({ form });
  };

  deleteGroup = (rowIndex, objIndex) => {
    const form = cloneDeep(this.state.form);
    const formGroups = [...form.groups[rowIndex]];

    formGroups.splice(objIndex, 1);
    form.groups[rowIndex] = formGroups;

    this.setState({ form });
  };

  removeNodeFromForm = (conceptKey) => {
    const form = cloneDeep(this.state.form);

    form[conceptKey] = null;

    this.setState({ form }, () => this.prepareData());
  };

  onGroupSizeSelectChange = (rowIndex, groupObjIndex, direction, value) => {
    const immutableForm = produce(this.state.form, mutableForm => {

      if (value === 'auto') delete mutableForm.groups[rowIndex][groupObjIndex][direction];
      else mutableForm.groups[rowIndex][groupObjIndex][direction] = value;
    });

    this.setState({ form: immutableForm });
  };

  onGroupTableSelect = (rowIndex, groupIndex, value) => {
    const immutableForm = produce(this.state.form, mutableForm => { 
      if (value) mutableForm.groups[rowIndex][groupIndex].tableId = value;
      else delete mutableForm.groups[rowIndex][groupIndex].tableId;
    });

    this.setState({ form: immutableForm });
  };

  onGroupFrmSelect = (rowIndex, groupIndex, value) => {
    const immutableForm = produce(this.state.form, mutableForm => {
      if (value) mutableForm.groups[rowIndex][groupIndex].frmId = value;
      else delete mutableForm.groups[rowIndex][groupIndex].frmId;
    });

    this.setState({ form: immutableForm });
  };

  onGroupFrmSelectAccordeonEdit = (rowIndex, groupIndex, value) => {
    const immutableForm = produce(this.state.form, mutableForm => {
      if (value) mutableForm.groups[rowIndex][groupIndex].frmEditId = value;
      else delete mutableForm.groups[rowIndex][groupIndex].frmEditId;
    });

    this.setState({ form: immutableForm });
  };

  removeRow = (rowIndex) => {
    const immutableForm = produce(this.state.form, mutableForm => {
      mutableForm.groups.splice(rowIndex, 1);
      if (mutableForm.tabs && mutableForm.tabsTitles)
      mutableForm.tabsTitles.splice(rowIndex, 1);
    });

    this.setState({ form: immutableForm });
  };

  onAccordeonRstChange = (rowIndex, groupIndex, value) => {
    let immutableForm;

    if (value) {
      immutableForm = produce(this.state.form, mutableForm => {
        mutableForm.groups[rowIndex][groupIndex].restrictions = [value];
        const group = mutableForm.groups[rowIndex][groupIndex];
        const groupConceptKey = group.concept_key;

        const accordeonFrmId = mutableForm.groups[rowIndex][groupIndex].frmId;
        const accordeonFrmEditId = mutableForm.groups[rowIndex][groupIndex].frmEditId;
        const accordeonTableId = mutableForm.groups[rowIndex][groupIndex].tableId;
        if (accordeonTableId && this.isNeedDeleteAccordeonView(value, accordeonTableId, groupConceptKey))
          delete mutableForm.groups[rowIndex][groupIndex].tableId;
        if (accordeonFrmId && this.isNeedDeleteAccordeonView(value, accordeonFrmId, groupConceptKey))
          delete mutableForm.groups[rowIndex][groupIndex].frmId;
        if (accordeonFrmEditId && this.isNeedDeleteAccordeonView(value, accordeonFrmEditId, groupConceptKey))
          delete mutableForm.groups[rowIndex][groupIndex].frmEditId;
      });

    } else {
      immutableForm = produce(this.state.form, mutableForm => {
        delete mutableForm.groups[rowIndex][groupIndex].restrictions;
        delete mutableForm.groups[rowIndex][groupIndex].frmEditId;
        delete mutableForm.groups[rowIndex][groupIndex].tableId;
        delete mutableForm.groups[rowIndex][groupIndex].items;
        delete mutableForm.groups[rowIndex][groupIndex].frmId;
      });
    }

    this.setState({ form: immutableForm });
  };

  isNeedDeleteAccordeonView = (accordeonPid, accordeonViewId, conceptKeyValue) => {
    const { light_meta_and_ops } = this.props;

    const concept = conceptKeyValue ? conceptKeyValue : get(this.props.jels, `jelData[${accordeonViewId}].concept`);
    const accordeonRst = getLastRstData(+accordeonPid, concept, light_meta_and_ops.setup_rbox_light);
    if (accordeonRst) {
      const accordeonRstSupers = get(light_meta_and_ops.setup_rbox_light, `nodes[${accordeonRst.oid}].box.t_supers_implicit`);

      if (accordeonRst.oid !== +concept
        || !accordeonRstSupers
        || !accordeonRstSupers.includes(concept)) return true;
    } else return true;
  };

  addGroupLink = (rowIndex, groupIndex) => {
    const form = cloneDeep(this.state.form);
    const group = { ...form.groups[rowIndex][groupIndex] };

    const link = {
      title: group.link_title,
      url: group.link_url,
      jel: group.link_jel,
      target: group.link_target,
    };

    form.groups[rowIndex][groupIndex].links = [...group.links, link];

    form.groups[rowIndex][groupIndex].link_title = '';
    form.groups[rowIndex][groupIndex].link_url = '';
    form.groups[rowIndex][groupIndex].link_jel = '';
    form.groups[rowIndex][groupIndex].link_target = false;

    this.setState({ form });
  };

  onRstDragEnd = (oldIndex, newIndex) => {
    const { rowIndex, groupIndex } = this.state.modalData;

    const form = cloneDeep(this.state.form);
    const group = { ...form.groups[rowIndex][groupIndex] };

    const arr = changeArrayElementPosition(group.items, oldIndex, newIndex);

    group.items = arr;
    form.groups[rowIndex][groupIndex] = group;

    this.setState({ form });
  };

  onLinkDragEnd = (oldIndex, newIndex) => {
    const { rowIndex, groupIndex } = this.state.modalData;

    const form = cloneDeep(this.state.form);
    const group = { ...form.groups[rowIndex][groupIndex] };

    const arr = changeArrayElementPosition(group.links, oldIndex, newIndex);

    group.links = arr;
    form.groups[rowIndex][groupIndex] = group;

    this.setState({ form });
  };

  toggleRstEditModal = (rowIndex, groupIndex, type, isOpened) => {
    this.setState({
      modalData: {
        rowIndex,
        groupIndex,
        type,
        isOpened,
      },
    });
  };

  removeNonExistingRestrictions = () => {
    const { conceptRestrictionsIds, form } = this.state;

    const immutableForm = produce(form, mutableForm => {
      mutableForm.groups.forEach(row => {
        row.forEach(group => {
          const groupConceptKey = group.concept_key ? group.concept_key : 'concept';

          if (!group.type || group.type === 'list') {
            group.items = group.items.filter(item => {
              const itemConceptKey = item.concept_key ? item.concept_key : 'concept';
              const itemPid = Array.isArray(item.pid) ? item.pid[0] : item.pid;
            
              if (
                (item.concept_key && !form[item.concept_key]) ||
                (!conceptRestrictionsIds[itemConceptKey]) ||
                (itemPid && !conceptRestrictionsIds[itemConceptKey].has(+itemPid))
              ) {
                return false;
              } else return true;
            });
          } else if (
            (!conceptRestrictionsIds[groupConceptKey] ||
            (conceptRestrictionsIds[groupConceptKey] && group.restrictions[0]
              && !conceptRestrictionsIds[groupConceptKey].has(+group.restrictions[0])))
          ) {
            group.restrictions = [];
            delete group.restrictions;
            delete group.concept_key;
            delete group.frmEditId;
            delete group.tableId;
            delete group.frmId;
          }
        });
      });
    })

    this.setState({ form: immutableForm });
  };

  openTableEditModal = (rowIndex, groupIndex, isEdit, concept) => {
    const form = cloneDeep(this.state.form);
    const { jels } = this.props;

    const editTblModal = { ...this.state.editTblModal };

    const newTable = {
      concept: concept ? concept : 0,
      title: '',
      show_pids: [],
      sort_pid: '',
      sort_by: '',
      rowsToShow: 50,
    };

    editTblModal.isOpened = true;
    editTblModal.rowIndex = rowIndex;
    editTblModal.groupIndex = groupIndex;

    editTblModal.data = isEdit ? jels.jelData[form.groups[rowIndex][groupIndex].tableId] : { ...newTable };

    this.setState({ editTblModal });
  };

  openFrmEditModal = (rowIndex, groupIndex, isEdit, frmEditId, type) => {
    const { form, ancestorsRstList } = this.state;
    const { jels } = this.props;

    const rstsAllConceptsList = 
      Object.values(ancestorsRstList)
      .flatMap(array => array);

    let conceptId = 0;
    const accordeonRid = get(form, `groups[${rowIndex}][${groupIndex}].restrictions[0]`);
    if (accordeonRid) {
      const rst = rstsAllConceptsList.find(rst => +accordeonRid === +rst.id);
      if (rst) conceptId = rst.oid;
    } else if (form.concept) conceptId = form.concept;

    const editFrmModal = { ...this.state.editFrmModal };

    const newFrm = {
      concept: conceptId,
      title: '',
      groups: [],
    };

    let frmId;

    if (!frmEditId) {
      frmId = form.groups[rowIndex][groupIndex].frmId;
      editFrmModal.data = isEdit ? jels.jelData[frmId] : { ...newFrm };
    } else {
      frmId = form.groups[rowIndex][groupIndex].frmEditId;
      editFrmModal.data = isEdit ? jels.jelData[frmEditId] : { ...newFrm };
    }

    editFrmModal.isOpened = true;
    editFrmModal.rowIndex = rowIndex;
    editFrmModal.groupIndex = groupIndex;
    editFrmModal.isEdit = isEdit;
    editFrmModal.type = type;

    this.setState({ editFrmModal });
  };

  setCreatedJel = (id, type, formType, formData) => {
    const form = cloneDeep(this.state.form);
    const groups = [...form.groups];
    const modalData = this.state[type === jelTypes.table ? 'editTblModal' : 'editFrmModal'];
    const editFrmModal = { ...this.state.editFrmModal }

    const { rowIndex, groupIndex } = modalData;

    if (!formType) {
      groups[rowIndex][groupIndex][type === jelTypes.table ? 'tableId' : 'frmId'] = id;
    } else {
      groups[rowIndex][groupIndex][formType] = id;
    }
    editFrmModal.data = formData;
    form.groups = groups;

    this.setState({ form });
    if (formData) this.setState({ editFrmModal });
  };

  setCreatedJelLink = (id, rowIndex, groupIndex, linkIndex) => {
    const immutableForm = produce(this.state.form, mutableForm => {

      if (linkIndex != null) {
        mutableForm.groups[rowIndex][groupIndex].links[linkIndex].jel = id;
      } else {
        mutableForm.groups[rowIndex][groupIndex].link_jel = id;
      }

    })

    this.props.updateJels();
    this.setState({ form: immutableForm });
  };

  setCreatedJelForm = (id, rowIndex, groupIndex, itemIndex) => {
    const immutableForm = produce(this.state.form, mutableForm => {
      mutableForm.groups[rowIndex][groupIndex].items[itemIndex].obj_editable_frm = id;
    })

    this.props.updateJels();
    this.setState({ form: immutableForm });
  };

  isPidsChainDuplicate = (pidsChain) => {
    const { form } = this.state;

    if (!form || !form.groups || !pidsChain) return false;
    const pidsChainStr = pidsChain.toString();

    let count = 0;
    for (let groups of form.groups) {
      for (let group of groups) {
        if (!group.items || !group.items.length) continue;
        for (let item of group.items) {
          if (item.pid && item.pid.toString() === pidsChainStr) count++;
        }
      }
    }
    return count > 1;
  };

  getUsedViews = (usedViews) => {
    if (usedViews && !isEqual(this.state.usedViews, usedViews)) this.setState({ usedViews });
  };

  render() {
    const {
      jels,
      setup,
      classes,
      modalIndex,
      deepCopyView,
      accountGroups,
      onCopyViewBtnClick,
      light_meta_and_ops,
    } = this.props;

    const {
      form,
      loaded,
      modalData,
      flowsValues,
      fetchingData,
      editTblModal,
      editFrmModal,
      formConcepts,
      deepCopyLoaded,
      isInAnotherJel,
      ancestorsRstList,
      addSecondaryConcepts,
      conceptRestrictionsIds,
    } = this.state;

    const selectedGroup = modalData.isOpened ? form.groups[modalData.rowIndex][modalData.groupIndex] : {};

    let hasNotValidRst = false;

    if (form && form.groups)
      form.groups.forEach((row) =>
        row.forEach((group) => {
          if (group.items) {
            group.items.forEach((item) => {
              const itemConceptKey = item.concept_key ? item.concept_key : 'concept';
              const itemPid = Array.isArray(item.pid) ? item.pid[0] : item.pid;

              if (item.type !== 'function') {
                if (
                  (!form[itemConceptKey]) ||
                  (!conceptRestrictionsIds[itemConceptKey]) ||
                  (itemPid && conceptRestrictionsIds[itemConceptKey] && !conceptRestrictionsIds[itemConceptKey].has(+itemPid))
                ) hasNotValidRst = true;
              }
            });
          }
        })
      );

    const isInAnotherJelHeight =
      isInAnotherJel && document.querySelector(`.is-in-another-jel-container`)
        ? document.querySelector(`.is-in-another-jel-container`).getBoundingClientRect().height + 22
        : '';

    const NestedTrplFormEdit = connect((state) => ({ jels: state.jels, light_meta_and_ops: state.meta.light_meta_and_ops }), { updateJels })(
      withStyles(styles)(TrplFormEdit)
    );

    const currentModalIndex = modalIndex ? modalIndex : 0;

    const setupRbox = light_meta_and_ops && light_meta_and_ops.setup_rbox_light;

    return (
      <div className={classes.mb100}>
        {form.id && isInAnotherJel ? (
          <div className={`is-in-another-jel-container ${classes.isInAnotherJelContainer}`}>
            <div style={{ textAlign: 'center' }}>
              <span className={`${classes.bold} ${classes.nowrap} ${classes.mr5}`}>{`${form.id} ${form.title}`}</span>
              <span className={`${classes.mr5} ${classes.nowrap}`}> is used in: </span>
              <span className={classes.bold}>{isInAnotherJel}</span>
            </div>

            <ButtonBase
              onClick={() => onCopyViewBtnClick(jelTypes.form, { ...form })}
              className={`${classes.btn} ${classes.secondaryBtn} ${classes.ml30}`}
              style={{
                visibility: `${jels.importedForms.includes(form.id) ? 'hidden' : ''}`,
              }}
            >
              Copy view
              <ContentCopyIcon
                style={{
                  fontSize: '13px',
                  marginLeft: '4px',
                  color: '#347CFF',
                }}
              />
            </ButtonBase>
          </div>
        ) : null}

        <FullScreenDialog
          id={form.id}
          onClose={() => {
            this.setState({
              editTblModal: {
                isOpened: false,
                data: {},
              },
            });

            this.props.updateJels();
          }}
          modalIndex={currentModalIndex}
          isOpen={editTblModal.isOpened}
          disableContainerPadding={true}
          title={
            editTblModal.data.id ? `Table edit - ${editTblModal.data.title} | ${editTblModal.data.id}` : 'Table create'
          }
        >
          <TableEdit
            id={editTblModal.data.id}
            parentJelId={form.id}
            settings={editTblModal.data}
            modalIndex={currentModalIndex + 1}
            setParentJel={this.setCreatedJel}
            deepCopyView={deepCopyView}
            onCopyViewBtnClick={onCopyViewBtnClick}
          />
        </FullScreenDialog>

        <FullScreenDialog
          onClose={() => {
            this.setState({
              editFrmModal: {
                isOpened: false,
                data: {},
              },
            });

            this.props.updateJels();
          }}
          isOpen={editFrmModal.isOpened}
          disableContainerPadding={true}
          modalIndex={currentModalIndex}
          title={
            editFrmModal.data.id ? `Form edit - ${editFrmModal.data.title} | ${editFrmModal.data.id}` : 'Form create'
          }
        >
          <NestedTrplFormEdit
            classes={classes}
            setupRbox={setupRbox}
            type={editFrmModal.type}
            form={editFrmModal.data}
            deepCopyView={deepCopyView}
            dashboard={editFrmModal.data}
            accountGroups={accountGroups}
            modalIndex={currentModalIndex}
            onCopyViewBtnClick={onCopyViewBtnClick}
            setParentJel={editFrmModal.isEdit ? null : this.setCreatedJel}
          />
        </FullScreenDialog>

        <div
          className={classes.container}
          style={{
            backgroundColor: '#fff',
            paddingTop: `${isInAnotherJel ? `${isInAnotherJelHeight}px` : ''}`,
          }}
        >
          {loaded || fetchingData ? (
            <React.Fragment>
              <div className={`${classes.spaceBetweenStart} ${classes.mb20}`}>
                <div className={`${classes.alignCenter} ${classes.mr10}`}>
                  <div className={`${classes.ml10} ${classes.row}`}>
                    {formConcepts && Object.keys(formConcepts) ? (
                      Object.keys(formConcepts).map(conceptKey => {
                        const conceptId = formConcepts[conceptKey];
                        if (setupRbox[conceptId]) return (
                          <Node
                            isLink
                            size="md"
                            isRemovable
                            key={conceptId}
                            nodeId={conceptId}
                            className={classes.mr10}
                            node={setupRbox[conceptId]}
                            nodes={setupRbox}
                            style={{ alignSelf: 'center' }}
                            onRemoveClick={() => this.removeNodeFromForm(conceptKey)}
                          />
                        )
                      })
                    ) : null}
                  </div>

                  <div className={`${classes.ml10}`}>
                    {addSecondaryConcepts || !form.concept ?
                      <Search
                        containerStyles={{
                          height: 24,
                        }}
                        conceptsOnly={true}
                        onDropdownElementClick={(params) => this.onConceptChange(params)}
                      />
                    :
                      <ButtonBase
                        disabled={false}
                        className={`${classes.btn} ${classes.secondaryBtn}`}
                        onClick={() => {
                          this.setState({ addSecondaryConcepts: true });
                        }}
                      >
                        + secondary concept
                      </ButtonBase>
                    }
                  </div>
                </div>

                {(fetchingData || !form || !form.id || !loaded) ? null :
                  <div className={`${classes.flex} ${classes.mr30}`}>
                    <div className={classes.ml10}>
                      <ViewUsesTree
                        node={form.id}
                        loaded={fetchingData}
                        classes={classes}
                        data={jels.jelData}
                        setUsedViewsToParent={this.getUsedViews}
                      />
                    </div>

                    {Object.keys(this.state.usedViews).length > 1 ?
                      <div className={`${classes.ml10}`}>
                        <ButtonBase
                          disabled={!deepCopyLoaded}
                          className={`${classes.btn} ${classes.secondaryBtn} ${classes.ml30}`}
                          onClick={() => {
                            this.setState({ deepCopyLoaded: false });
                            deepCopyView(form.id, this.state.usedViews, () => this.setState({ deepCopyLoaded: true }));
                          }}
                        >
                          {deepCopyLoaded ?
                            <React.Fragment>
                              Copy view deep
                              <ContentCopyIcon
                                style={{
                                  fontSize: '13px',
                                  marginLeft: '4px',
                                  color: '#347CFF',
                                }}
                              />
                            </React.Fragment>
                          : <LoaderNew/>}
                        </ButtonBase>
                      </div>
                    : null}
                  </div>
                }
              </div>

              <TrplFormEditModal
                form={form}
                setup={setup}
                classes={classes}
                modalData={modalData}
                setupRbox={setupRbox}
                formConcepts={formConcepts}
                deepCopyView={deepCopyView}
                modalIndex={currentModalIndex}
                accountGroups={accountGroups}
                selectedGroup={selectedGroup}
                addGroupLink={this.addGroupLink}
                onRstDragEnd={this.onRstDragEnd}
                onLinkDragEnd={this.onLinkDragEnd}
                addInnerRstCb={this.addInnerRstCb}
                removeInnerRst={this.removeInnerRst}
                removeGroupLink={this.removeGroupLink}
                onCopyViewBtnClick={onCopyViewBtnClick}
                setCreatedJelLink={this.setCreatedJelLink}
                setCreatedJelForm={this.setCreatedJelForm}
                onGroupLinkChange={this.onGroupLinkChange}
                toggleRstEditModal={this.toggleRstEditModal}
                onGroupFieldChange={this.onGroupFieldChange}
                isPidsChainDuplicate={this.isPidsChainDuplicate}
                conceptRestrictionsIds={conceptRestrictionsIds}
                onGroupRstFieldChange={this.onGroupRstFieldChange}
                onGroupRstSelectChange={this.onGroupRstSelectChange}
                onRemoveRstFromGroupClick={this.onRemoveRstFromGroupClick}
                onGroupComponentFieldChange={this.onGroupComponentFieldChange}
              />

              <div className={`${classes.mb20} ${classes.alignCenter}`}>
                <div className={classes.alignCenter}>
                  <TextField
                    label="Title"
                    value={form.title}
                    className={`${classes.tableCellHeading} ${classes.w300} ${classes.mr10}`}
                    onChange={(e) => {
                      const form = { ...this.state.form };

                      form.title = e.target.value;

                      this.setState({ form });
                    }}
                  />

                  <TextField
                    label="Func"
                    value={form.func || ''}
                    className={`${classes.tableCellHeading} ${classes.w200} ${classes.mr10}`}
                    onChange={(e) => {
                      const form = { ...this.state.form };

                      form.func = e.target.value;

                      this.setState({ form });
                    }}
                  />

                  <div className={`${classes.mr10} ${classes.w200}`}>
                    <TrplSelect
                      title="Flow"
                      margin="none"
                      complicatedValues
                      values={flowsValues}
                      value={form.flow || 'none'}
                      onChange={(e) => {
                        const form = { ...this.state.form };

                        if (e.target.value === 'none') {
                          delete form.flow;
                        } else {
                          form.flow = e.target.value;
                        }
                        this.setState({ form });
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '-12px', marginLeft: '20px'}}>
                    <TrplCheckbox
                      label="Mobile form"
                      disableRipple
                      checked={form.is_mobile || false}
                      classes={{
                        root: classes.checkboxGray,
                        label: classes.checkboxLabel,
                      }}
                      onChange={(e) => {
                        const form = { ...this.state.form };

                        form.is_mobile = e.target.checked;
                        this.setState({ form });
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '-12px' }}>
                    <TrplCheckbox
                      label="Display rows as tabs"
                      disableRipple
                      checked={form.tabs || false}
                      classes={{
                        root: classes.checkboxGray,
                        label: classes.checkboxLabel,
                      }}
                      onChange={(e) => {
                        const form = { ...this.state.form };

                        form.tabs = e.target.checked;
                        this.setState({ form });
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '-12px' }}>
                    <TrplCheckbox
                      label="Submit only"
                      disableRipple
                      checked={form.submit_only || false}
                      classes={{
                        root: classes.checkboxGray,
                        label: classes.checkboxLabel,
                      }}
                      onChange={(e) => {
                        const form = { ...this.state.form };

                        form.submit_only = e.target.checked;
                        this.setState({ form });
                      }}
                    />
                  </div>

                  <div style={{ marginBottom: '-12px' }}>
                    <TrplCheckbox
                      label="Save only"
                      disableRipple
                      checked={form.save_only || false}
                      classes={{
                        root: classes.checkboxGray,
                        label: classes.checkboxLabel,
                      }}
                      onChange={(e) => {
                        const form = { ...this.state.form };

                        form.save_only = e.target.checked;
                        this.setState({ form });
                      }}
                    />
                  </div>
                </div>

                {hasNotValidRst ? (
                  <ButtonBase
                    onClick={this.removeNonExistingRestrictions}
                    className={`${classes.btn} ${classes.secondaryBtn} ${classes.removeNotValidRstrsBtn}`}
                    style={{ marginBottom: '-12px' }}
                  >
                    <Clear style={{ fontSize: 15, marginRight: '5px' }} />
                    <span
                      style={{
                        whiteSpace: 'nowrap',
                      }}
                    >
                      Remove all nonexistent predicates
                    </span>
                  </ButtonBase>
                ) : null}
              </div>

              {form.groups ? (
                <div className={classes.mb20}>
                  {form.groups.map((row, rowIndex) => {
                    let atLeastOneGroupHasWidth = false;

                    if (form.tabs) {
                      if (!form.tabsTitles) form.tabsTitles = [];
                      if (!form.tabsTitles[rowIndex]) form.tabsTitles[rowIndex] = '';
                    }
                    
                    row.forEach((group) => {
                      if (group.width) atLeastOneGroupHasWidth = true;
                    });

                    return (
                      <div key={rowIndex} className={classes.groupsRow}>
                        {form.tabs &&
                          <div style={{ marginLeft: '20px' }}>
                            <TextField
                              label="Tab title"
                              value={form.tabsTitles[rowIndex] || ''}
                              className={`${classes.tableCellHeading} ${classes.w300} ${classes.mr10}`}
                              onChange={(e) => {
                                const form = { ...this.state.form };

                                form.tabsTitles[rowIndex] = e.target.value;

                                this.setState({ form });
                              }}
                            />
                          </div>
                          }
                        <div
                          key={rowIndex}
                          className={`${classes.flex} ${classes.mb10}`}
                          style={{
                            alignItems: 'flex-start',
                            flexWrap: `${atLeastOneGroupHasWidth ? 'wrap' : 'nowrap'}`,
                          }}
                        >
                          {row.map((groupObj, groupObjIndex) => {
                            return (
                              <Card
                                key={groupObjIndex}
                                style={{
                                  margin: '5px',
                                  overflow: 'visible',
                                  boxShadow: '0px 2px 3px rgba(0, 0, 0, 0.06)',
                                  width: `${groupObj.width ? `calc(${groupObj.width} - ${colPadding})` : '100%'}`,
                                  flexShrink: `${groupObj.width ? '0' : '1'}`,
                                }}
                              >
                                {groupObj.type && groupObj.type === 'accordeon' ? (
                                  <AccordeonEdit
                                    group={groupObj}
                                    classes={classes}
                                    rowIndex={rowIndex}
                                    setupRbox={setupRbox}
                                    formConcepts={formConcepts}
                                    groupIndex={groupObjIndex}
                                    groupsLength={row.length - 1}
                                    deleteGroup={this.deleteGroup}
                                    openFrmEditModal={this.openFrmEditModal}
                                    onGroupFrmSelect={this.onGroupFrmSelect}
                                    onGroupFieldChange={this.onGroupFieldChange}
                                    changeGroupPosition={this.changeGroupPosition}
                                    conceptRestrictionsIds={conceptRestrictionsIds}
                                    onAccordeonRstChange={this.onAccordeonRstChange}
                                    onGroupSizeSelectChange={this.onGroupSizeSelectChange}
                                    onGroupFrmSelectAccordeonEdit={this.onGroupFrmSelectAccordeonEdit}
                                  />
                                ) : groupObj.type && groupObj.type === 'table' ? (
                                    
                                  <TableChildEdit
                                    group={groupObj}
                                    classes={classes}
                                    rowIndex={rowIndex}
                                    setupRbox={setupRbox}
                                    formConcepts={formConcepts}
                                    groupIndex={groupObjIndex}
                                    deleteGroup={this.deleteGroup}
                                    groupsLength={row.length - 1}
                                    openTableEditModal={this.openTableEditModal}
                                    onGroupFieldChange={this.onGroupFieldChange}
                                    onGroupTableSelect={this.onGroupTableSelect}
                                    changeGroupPosition={this.changeGroupPosition}
                                    onAccordeonRstChange={this.onAccordeonRstChange}
                                    onGroupSizeSelectChange={this.onGroupSizeSelectChange}
                                  />
                                ) : groupObj.type && groupObj.type === 'links' ? (
                                  <DashboardEdit
                                    group={groupObj}
                                    classes={classes}
                                    rowIndex={rowIndex}
                                    groupIndex={groupObjIndex}
                                    groupsLength={row.length - 1}
                                    deleteGroup={this.deleteGroup}
                                    onGroupFieldChange={this.onGroupFieldChange}
                                    toggleRstEditModal={this.toggleRstEditModal}
                                    changeGroupPosition={this.changeGroupPosition}
                                    onGroupSizeSelectChange={this.onGroupSizeSelectChange}
                                  />
                                ) : (
                                  <ListEdit
                                    group={groupObj}
                                    classes={classes}
                                    rowIndex={rowIndex}
                                    setupRbox={setupRbox}
                                    formConcepts={formConcepts}
                                    groupIndex={groupObjIndex}
                                    deleteGroup={this.deleteGroup}
                                    groupsLength={row.length - 1}
                                    ancestorsRstList={ancestorsRstList}
                                    toggleRstEditModal={this.toggleRstEditModal}
                                    onGroupFieldChange={this.onGroupFieldChange}
                                    changeGroupPosition={this.changeGroupPosition}
                                    isPidsChainDuplicate={this.isPidsChainDuplicate}
                                    conceptRestrictionsIds={conceptRestrictionsIds}
                                    onGroupSizeSelectChange={this.onGroupSizeSelectChange}
                                  />
                                )}
                              </Card>
                            );
                          })}
                        </div>

                        <div style={{ padding: '0px 5px 5px 5px' }} className={`${classes.spaceBetween}`}>
                          <div className={classes.alignCenter}>
                            {rowIndex !== 0 ? (
                              <KeyboardArrowUpOutlinedIcon
                                className={`${classes.pointer} ${classes.mr10}`}
                                onClick={() => this.changeRowPosition(rowIndex, rowIndex - 1)}
                              />
                            ) : null}

                            {rowIndex !== form.groups.length - 1 ? (
                              <KeyboardArrowDownOutlinedIcon
                                className={`${classes.pointer}`}
                                onClick={() => this.changeRowPosition(rowIndex, rowIndex + 1)}
                              />
                            ) : null}
                          </div>
                          <div className={classes.alignCenter}>
                            <div className={`${classes.w300} ${classes.mr10}`}>
                              <TrplSelect
                                title="Type"
                                margin="none"
                                complicatedValues
                                values={itemTypesValues}
                                value={form.groups[rowIndex].add_group_type || 'list'}
                                onChange={(e) => {
                                  const form = { ...this.state.form };

                                  form.groups[rowIndex].add_group_type = e.target.value;

                                  this.setState({ form });
                                }}
                              />
                            </div>

                            <Button
                              size="small"
                              variant="contained"
                              className={classes.mr10}
                              onClick={() => this.addNewGroup(rowIndex, form.groups[rowIndex].add_group_type)}
                            >
                              Add group
                            </Button>
                            <Button
                              size="small"
                              color="secondary"
                              variant="contained"
                              onClick={() => this.removeRow(rowIndex)}
                            >
                              Remove row
                            </Button>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              ) : null}

              <div className={classes.spaceBetween}>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {
                    const form = { ...this.state.form };

                    form.groups.push([]);

                    this.setState({ form });
                  }}
                >
                  Add row
                </Button>

                {(jels && !jels.importedForms) || (jels.importedForms && !jels.importedForms.includes(form.id)) &&
                  <Button size="small" variant="contained" color="primary" onClick={this.onSaveFormClick}>
                    {fetchingData ? <LoaderNew color='#FFF' style={{ height: '22.75px' }} /> : 'Save'}
                  </Button>
                }
              </div>
            </React.Fragment>
          ) : (
              <div
                style={{
                  display: 'flex',
                  paddingTop: '50px',
                  justifyContent: 'center',
                }}
              >
                <LoaderNew />
              </div>
            )}
        </div>
      </div>
    );
  }
};

export default connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
  accounts_tbox: state.meta.accounts_tbox,
  light_meta_and_ops: state.meta.light_meta_and_ops,
}), {
  updateJels,
  updateJelsSimple,
})(withStyles(styles)(TrplFormEdit));
